import { useDispatch } from 'react-redux';
import { rootActions } from 'Store';
import { EmptyAction } from 'typesafe-actions';

interface JoinSocketRoom {
  (): void;
}

export default () => {
  const dispatch = useDispatch();

  return [
    ((): EmptyAction<string> =>
      dispatch(rootActions.user.joinSocketRoom())) as JoinSocketRoom,
  ] as const;
};
